import TextInput from "components/controls/TextInput";
import { useForm } from "modules/forms";
import { StyledControlContainer } from "shared/styled/control.styled";
import { StyledPanelTitle } from "shared/styled/panel.stayled";
import { OpportunityEntity } from "shared/types/domain/OpportunityEntity";

interface OpportunityDetailsProps {
    readOnly: boolean;
};

const OpportunityDetails = ({
    readOnly
}: OpportunityDetailsProps) => {

    const { formData, updateFields, formErrors } = useForm<OpportunityEntity>();

    return (
        <>
            <StyledPanelTitle>{"Explanation of Opportunity"}</StyledPanelTitle>

            <StyledControlContainer>
                <TextInput
                    label={"Details"}
                    multiline
                    value={formData?.whatHappened}
                    errorMessage={formErrors?.whatHappened}
                    onChange={(e, v) => updateFields({
                        whatHappened: { runValidation: true, value: v }
                    })}
                    disabled={readOnly}
                    required
                />
            </StyledControlContainer>
        </>
    )
};

export default OpportunityDetails;